// Frontend constants that mirror backend/app/common/token_constants.py
// This ensures consistency across the entire application

// Core popular token symbols used throughout the system
export const POPULAR_TOKENS = ["BTC", "ETH", "SOL", "BNB", "MATIC", "AVAX", "ADA", "DOT", "LINK", "UNI", "CAKE", "GTAI"];

// Popular tokens for the main display (first 6)
export const DISPLAY_POPULAR_TOKENS = POPULAR_TOKENS.slice(0, 6);

// Banned symbols that should never be displayed
export const BANNED_SYMBOLS = new Set(['HERO', 'RACA', 'HODL', 'SHIB', 'BABYDOGE', 'SAFEMOON', 'FLOKI']);

// Banned names that should never be displayed
export const BANNED_NAMES = new Set(['MetaHero', 'Radio Caca V2', 'HODL']);

// Token display names mapping
export const TOKEN_DISPLAY_NAMES = {
  'BTC': 'Bitcoin',
  'ETH': 'Ethereum', 
  'BNB': 'BNB',
  'ADA': 'Cardano',
  'SOL': 'Solana',
  'DOT': 'Polkadot',
  'CAKE': 'PancakeSwap',
  'USDT': 'Tether USD',
  'GTAI': 'GTAI Token'
};
